module.exports = __webpack_public_path__ + "img/空.f94d7034.png";